import React, { useCallback, useState } from 'react'
import styled from 'styled-components'
import { useTranslation } from '@pancakeswap/localization'
import { Modal, Button, Flex, Input, Text } from '@pancakeswap/uikit'
import useCatchTxError from 'hooks/useCatchTxError'
import useToast from 'hooks/useToast'
import useLockToken from '../../../hooks/v2/useLockToken'

const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-top: 6px;

  svg {
    width: 24px;
  }
`

const StyledInput = styled(Input)`
  box-shadow: none;
  padding: 0 8px;
  height: 42px;
  width: 100%;
  font-size: 14px;
  z-index: 1;
  border-radius: 6px;

  ${({ theme }) => theme.mediaQueries.sm} {
    font-size: 16px;
    width: 450px;
  }
`

const Display = styled(Text)`
  font-size: 16px;
  font-weight: 500;
`

interface Props {
  id: number
  onDismiss?: () => void
}

const LockTransferModal: React.FC<Props> = ({
  id,
  onDismiss
}) => {
  const [value, setValue] = useState('')

  const { t } = useTranslation()
  const { toastSuccess, toastError } = useToast()
  const { fetchWithCatchTxError, loading: pendingTx } = useCatchTxError()

  const { onTransfer } = useLockToken()

  const handleChange = useCallback(
    (e: React.FormEvent<HTMLInputElement>) => {
      setValue(e.currentTarget.value.trim())
    },
    [],
  )

  const handleTransfer = async () => {
    const receipt = await fetchWithCatchTxError(() => {
      return onTransfer(id, value)
    })
    if (receipt?.status) {
      toastSuccess(
        `${t('Transferred')}!`,
        t('Your lock has been transferred to new owner'),
      )
      onDismiss()
    }
  }

  return (
    <Modal title="Transfer Lock" onDismiss={onDismiss}>
      <InputWrapper>
        <Display>{t('New Owner')}</Display>
        <StyledInput
          pattern="^(0x)?[0-9a-fA-F]{40}$"
          disabled={pendingTx}
          onChange={handleChange}
          placeholder="0x0000000000000000000000000000000000000000"
          value={value}
        />
      </InputWrapper>
      <Flex justifyContent="space-between" mt="24px">
        <Button width='100%' variant="secondary" onClick={onDismiss} mr="8px">
          Cancel
        </Button>
        <Button
          width='100%'
          disabled={pendingTx || !value}
          onClick={handleTransfer}
        >
          Transfer
        </Button>
      </Flex>
    </Modal>
  )
}

export default LockTransferModal
